import { LegalLayout, LegalSection } from "@/pages/LegalPage";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <p className="text-[15px]" data-testid="terms-intro">
        These terms govern your use of Tugboat. By creating an account or embedding the widget, you agree to them.
      </p>

      <LegalSection heading="The service">
        <p>Tugboat provides an embeddable feedback widget and a dashboard to collect, view, triage, and manage beta
          feedback. We may update features over time. Beta features are provided as-is.</p>
      </LegalSection>

      <LegalSection heading="Accounts">
        <p>You're responsible for your account, the security of your credentials, and the activity of your workspace
          members. Keep your contact details accurate.</p>
      </LegalSection>

      <LegalSection heading="Acceptable use">
        <p>Don't use Tugboat to collect data unlawfully, capture content without the necessary rights or consent, upload
          malware, or attempt to disrupt or reverse-engineer the service. You must give your own testers appropriate
          notice and obtain any consent required by law before capturing their feedback, screen, or voice.</p>
      </LegalSection>

      <LegalSection heading="Your content">
        <p>You and your testers retain ownership of submitted feedback. You grant Tugboat the limited rights needed to
          store, process, and display that content to operate the service for you.</p>
      </LegalSection>

      <LegalSection heading="Plans & billing">
        <p>Paid plans and limits are described on our pricing page. During the current beta, plan changes may be applied
          manually. Pricing and limits may change with notice.</p>
      </LegalSection>

      <LegalSection heading="Availability & liability">
        <p>The service is provided "as is" without warranties. To the maximum extent permitted by law, Tugboat is not
          liable for indirect or consequential damages, and our total liability is limited to the fees you paid in the
          prior 12 months.</p>
      </LegalSection>

      <LegalSection heading="Termination">
        <p>You may stop using Tugboat at any time. We may suspend or terminate accounts that violate these terms.</p>
      </LegalSection>

      <LegalSection heading="Contact">
        <p>Questions about these terms? <a href="mailto:hello@tugboatapp.com" className="text-orange font-700">hello@tugboatapp.com</a></p>
      </LegalSection>
    </LegalLayout>
  );
}
